import React from 'react'

function DomainProfileStatus(is_company) {
    return(
        <React.Fragment>
            {is_company && <span className="badge badge-flat border-success text-success-600">Công Ty</span>}
            {!is_company && <span className="badge badge-flat border-primary text-primary-600">Cá Nhân</span>}
        </React.Fragment>
    )
}


export default DomainProfileStatus;